module.exports = global["surveylab_charts_gvizDrawChart"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./gviz-draw-chart.ts");